module.exports = __webpack_public_path__ + "img/whatsapp.9bc78ebf.png";